// Liste satırları için istemci tarafı sabit anahtar (React key) — sunucuya gönderilmez
export const uid = () => Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
